import { observer } from 'mobx-react';
import * as React from 'react';
import TimeZone from '../../../../TimeZone';
import { InviteParticipantStoreActions } from '../RenderInviteParticipantsModal';
import { Inviting, Submitting } from '../Types';
import DateInput from './DateInput';
import Time from './Time';

export interface Props {
  state: Inviting | Submitting;
  actions: Omit<InviteParticipantStoreActions, 'back'>;
}

const handleSubmit =
  (submit: () => void) =>
  (e: React.SyntheticEvent): void => {
    e.preventDefault();
    submit();
  };

function Form({ actions, state }: Props) {
  return (
    <form onSubmit={handleSubmit(actions.submit)} tabIndex={0} className="flex mt-6">
      <DateInput setDate={actions.setDate} date={state.date} disabled={state.skipCommunications} />
      <Time setTime={actions.setTime} time={state.time} disabled={state.skipCommunications} />
      <TimeZone
        setTimezone={actions.setTimezone}
        timezone={state.timezone}
        disabled={state.skipCommunications}
      />
      <input type="submit" hidden />
    </form>
  );
}

export default observer(Form);
